<template>
    <div>
        <SOSlotModal :modal-title="modalTitle" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div class="pt-4">
                    <div v-if="!data.wa_autosender">
                        Invoice akan dikirimkan ke 
                        <span class="f-bold">{{ $route.params.penerima }} </span>melalui Nomor Smartlink
                        dengan Tarif 125/pesan. Jika ingin mengirim menggunakan nomor anda sendiri,
                        Daftarkan nomor anda di fitur <span class="f-bold" @click="goWaAutoSender()">WA Autosender.</span>
                    </div>
                    <div v-else>
                        Invoice akan dikirimkan ke <span class="f-bold">{{$route.params.penerima}} </span>melalui Device WA Autosender 
                        <span class="f-bold">[ {{ data.nama_device }} - {{ data.nomor_device }}] , Pastikan WA Autosender Anda Aktif. </span>
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>
                <SOButton
                    :primary="true"
                    :full="true"
                    :text="'Kirim Invoice'"
                    :id="`confirm-send`"
                    :disable="isLoading"
                    :loading="isLoading"
                    @action="doConfirmAndSend()"
                />
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { moduleName } from "../../store/state";
import { mapGetters, mapActions } from "vuex";
import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../../apiEndPoint.js";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
    name: "ConfirmSendInvoice",
    components: { 
        SOSlotModal, 
        SOButton
    },
    data() {
        return {
            modalId: "confirm-send-invoice",
            modalTitle: "Kirim Invoice",
            data: {},
            isLoading: false,
        }
    },
    methods: {
        ...mapActions({
            sendWaInvoice: `${moduleName}/sendWaInvoice`,
        }),
        async getInvoiceWaData() {
            try {
                const res = await conn.get(api.getDataInvoiceWASender + this.$route.params.idoutlet);
                if (!this.data.length) {
                        this.data = res.data.data
                    }
                    else {
                        res.data.data.forEach(element => {
                            this.data.push(element);
                        });
                    }
            } catch (e) {
                console.log(error);
                return resulter.errorResult(e)
            }
        },
        async back(idx = -1) {
            await this.$router.go(idx);
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        doConfirmAndSend(){
            this.isLoading = true;
            this.sendWaInvoice(this.$route.params.invoiceId)
                .then((res) => {
                    if (!res.status) {
                        this.$toast.error(res);
                    } else {
                        let { code, data, status, msg } = res.data;
                        if (code === 200 && status) {
                            this.$toast.success(msg);
                            this.isLoading = false;
                            this.$router.go(-1);
                        } else {
                            this.isLoading = false;
                            this.$toast.error(msg);
                        }
                    }
                })
                .catch((e) => {
                    this.isLoading = false; 
                    this.$toast.error(e);
                });
        },
        goWaAutoSender(){
            this.$router.push({ name: "wa_autosender.daftar_perangkat" });
        },
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
        this.getInvoiceWaData();
    },
}
</script>